import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export default function Breadcrumbs({ items }) {
  return (
    <nav className="flex items-center flex-wrap gap-1 text-sm mb-5" dir="rtl" data-testid="breadcrumbs">
      {items.map((it, i) => (
        <React.Fragment key={i}>
          {i > 0 && <ChevronLeft size={14} className="opacity-40" />}
          {it.to ? (
            <Link to={it.to} className="text-primary hover:underline font-eng-mixed">
              {it.label}
            </Link>
          ) : (
            <span className="text-muted-foreground">{it.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}
